import { ButtonShape, ButtonSize, ButtonMinMaxSizes } from '../types'
import { css } from 'styled-components'
import SvgIcon from '../../Icon/SvgIcon'

export const getButtonDimensions = (shape: ButtonShape, size: ButtonSize) => {
  switch (size) {
    case 'large':
      return getLargeButtonDimensions(shape)
    case 'medium':
      return getMediumButtonDimensions(shape)
    case 'small':
      return getSmallButtonDimensions(shape)
  }

  throw new Error(`${size} ${shape} button is not defined!`)
}

const getLargeButtonDimensions = (shape: ButtonShape) => css`
  height: 40px;

  ${shape === 'rectangle' &&
  css`
    font-size: 14px;
    padding: 0px 16px;
    border-radius: 5px;
  `}

  ${shape === 'circle' &&
  css`
    width: 40px;
    border-radius: 50%;

    ${SvgIcon} svg {
      width: 48px;
      height: 48px;
    }
  `}
`

const getMediumButtonDimensions = (shape: ButtonShape) => css`
  height: 32px;

  ${shape === 'rectangle' &&
  css`
    font-size: 13px;
    padding: 0px 16px;
    border-radius: 5px;
  `}

  ${shape === 'circle' &&
  css`
    width: 32px;
    border-radius: 50%;

    ${SvgIcon} svg {
      width: 42px;
      height: 42px;
    }
  `}
`

const getSmallButtonDimensions = (shape: ButtonShape) => css`
  height: 24px;

  ${shape === 'rectangle' &&
  css`
    font-size: 12px;
    padding: 0px 8px;
    border-radius: 5px;
  `}

  ${shape === 'circle' &&
  css`
    width: 24px;
    border-radius: 50%;

    ${SvgIcon} svg {
      width: 32px;
      height: 32px;
    }
  `}
`

export const getButtonMinMaxSizes = (sizes: ButtonMinMaxSizes) => {
  const { minWidth, minHeight, maxWidth, maxHeight } = sizes

  return css`
    ${minWidth !== undefined &&
    css`
      min-width: ${minWidth}px;
    `}

    ${minHeight !== undefined &&
    css`
      min-height: ${minHeight}px;
    `}


    ${maxWidth !== undefined &&
    css`
      max-width: ${maxWidth}px;
    `}

    ${maxHeight !== undefined &&
    css`
      max-height: ${maxHeight}px;
    `}
  `
}
